import type { FC } from "react";
import { createStepIfEmptyAtomEffect, editableStepsAtom } from "@/routes/automations/automation-details-page/state";
import { useAtom, useAtomValue } from "jotai";
import AutomationStepEditArea from "@/routes/automations/automation-edit-page/AutomationStepEditArea";
import { AutomationStepList } from "@/routes/automations/automation-details-page/AutomationStepList";
import { AutomationEmptyStepCreator } from "@/routes/automations/automation-edit-page/AutomationEmptyStepCreator";
import { StepListContainer } from "@/routes/automations/automation-details-page/StepListContainer";

export const AutomationDefinitionSectionEdit: FC = () => {
    const editableSteps = useAtomValue(editableStepsAtom);
    useAtom(createStepIfEmptyAtomEffect);

    if (editableSteps === null) {
        return null;
    }

    return (
        <StepListContainer className={"rounded-none border-b-0 border-l-0 border-r-0 border-t"}>
            {editableSteps.length === 0 ? (
                <AutomationEmptyStepCreator />
            ) : (
                <div className="flex w-full max-w-screen-xl grow flex-row items-start justify-center gap-4">
                    <AutomationStepList steps={editableSteps} />
                    <AutomationStepEditArea />
                </div>
            )}
        </StepListContainer>
    );
};
